import React, { useState } from "react";

import { useTranslation } from "utils";

import { ErrorBoundary, MainPage, ScreenError } from "components";

const ErrorPage = () => {
  const { t } = useTranslation(["global"]);

  const [share] = useState({
    title: t("errorPage.headline"),
    summary: t("errorPage.description"),
  });

  return (
    <MainPage loading={false} pageName={"page"} share={share}>
      <ErrorBoundary>
        <ScreenError headline={t("errorPage.headline")} description={t("errorPage.description")} buttonText={t("errorPage.button")} />
      </ErrorBoundary>
    </MainPage>
  );
};

export default ErrorPage;
